<template>
  <section class="iconos">
    <ul class="listado-iconos">
      <li>
          <img src="../../assets/img/icono_cafe.svg" alt="Icono Cafe">
          <p>Café</p>
      </li>
      <li>
          <img src="../../assets/img/icono_postre.svg" alt="Icono Postre">
          <p>Postre</p>
      </li>
      <li>
          <img src="../../assets/img/icono_te.svg" alt="Icono Té">
          <p>Té</p>
      </li>
    </ul>
  </section>
</template>

<style scoped>
.iconos {
  margin-top: 4rem;
}
@media (min-width: 768px) {
  .iconos .listado-iconos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5rem;
  }
}
.iconos .listado-iconos li img {
  margin: 0 auto;
  width: 15rem;
}
.iconos .listado-iconos li p {
  font-family: "Bona Nova", serif;
  font-size: 3rem;
  color: #5e311e;
}
</style>